// extracted by mini-css-extract-plugin
export default {"card-container":"LotteryTemplate_card-container__75T7A","card":"LotteryTemplate_card__sW-Bb"};